import { AB_EXPERIMENTS, type AbExperiment } from './experiments'

const activeComponents = new Set(
  AB_EXPERIMENTS.flatMap((experiment: AbExperiment) =>
    experiment.status === 'running'
      ? experiment.scopes.flatMap((scope) => (scope.match === 'component' && scope.component ? [scope.component] : []))
      : []
  )
)

/** Unsampled, once per page/component, including cards arriving in a streamed response. */
export const COMPONENT_EXPOSURE_EVENT = 'experiment-component-exposure'

/** A marker carries its public path so an outgoing SPA tree cannot enroll the next page. */
export const readExperimentComponents = (pathname: string): string[] => [
  ...new Set(
    Array.from(document.querySelectorAll<HTMLElement>('[data-ab-component]'))
      .filter((element) => element.dataset.abPath === pathname)
      .map((element) => element.dataset.abComponent)
      .filter((component): component is string => !!component && activeComponents.has(component))
  ),
]
